import * as React from 'react';
import * as main from '../../../styles/mainOld.module.scss';
import * as modules from './modules.module.scss';
import { modulesData } from './data/modulesData';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material';
import { Modal } from '../../../../../Modal';
import { TaxDeduction } from "../../../../../TaxDeduction";

const StyledAccordion = styled(Accordion)({
  marginTop: '20px',
  boxShadow: 'unset',
  backgroundColor: 'unset',
  '&::before': {
    display: 'none',
  },
});

const StyledSummary = styled(AccordionSummary)({
  background: 'linear-gradient(128.1deg, #F3E7FF 42.7%, #DAB6FF 103.57%)',
  borderRadius: '15px',
  padding: '20px 30px',
  cursor: 'pointer',
  '@media (max-width: 768px)': {
    padding: '15px',
  },
  '&:after': {
    content: "''",
    position: 'absolute',
    right: '40px',
    top: 'calc(50% - 25px)',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundImage: 'url(https://fs.advance.ru/landing-pages/online/uchis_uchitsya_old/arrow.png)',
    backgroundColor: '#afa6ff',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    transform: 'rotate(180deg)',
    transition: 'all .2s ease-in',
    '@media (max-width: 768px)': {
      right: '30px',
      top: 'calc(50% - 20px)',
      width: '40px',
      height: '40px',
      backgroundSize: '50%',
    },
  },
  '&.Mui-expanded': {
    '&:after': {
      backgroundColor: '#5245cd',
      transform: 'rotate(0deg)',
    },
  },
  '.MuiAccordionSummary-content': {
    alignItems: 'center',
    margin: 0,
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
});

const StyledDetails = styled(AccordionDetails)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '30px 0',
  '@media (max-width: 768px)': {
    paddingTop: '15px',
    paddingBottom: '15px',
  },
});

export const Modules = ({ data = { modulesData }, buttonText, widget, free=false }) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <section className={modules.modules}>
      <div className="container">
        <h2 className={`${main.titleH2} ${modules.modules__title}`}>Основные навыки и краткое содержание курса</h2>
        {modulesData.map((elem, index) => (
          <StyledAccordion key={index} disableGutters={true} square>
            <StyledSummary>
              <h3 className={modules.modules__bage}>{elem.bage}</h3>
              <h3 className={modules.modules__subtitle}>{elem.title}</h3>
            </StyledSummary>
            <StyledDetails>
              <div className={modules.modules__description}>{elem.description}</div>

              <div className={modules.modules__result}>
                <h3 className={modules.modules__resultTitle}>Результат модуля:</h3>
                <div className="row">{elem.result}</div>
              </div>

              <button
                className={main.btn}
                onClick={() => {
                  setShowModal(true);
                }}
              >
                {buttonText}
              </button>
              { !free && <TaxDeduction margin={"30px 0 0"} align={"center"}/> }
            </StyledDetails>
          </StyledAccordion>
        ))}
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
};
